const baseConfig = {
pageNo:1,
pageSize:10
}
module.exports = baseConfig